module.exports = __webpack_public_path__ + "img/animals_01_H.470041c4.webp";